/**
 * @generated SignedSource<<2370e65fdbe1e4d38b4f61ff00caff76>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssetsGroupKey = "CRYPTO" | "ETC" | "ETF" | "INDEX" | "METAL" | "STOCK";
export type AssetsListGroup = "COIN" | "EQUITY_COMPLEX_ETC" | "EQUITY_COMPLEX_ETF" | "EQUITY_ETC" | "EQUITY_ETF" | "EQUITY_STOCK" | "ETC" | "ETF" | "INDEX" | "METAL" | "SECURITY_TOKEN" | "STOCK" | "TOKEN";
export type AssetsListSortBy = "MARKETCAP" | "NAME" | "PRICE" | "PRICE_CHANGE_1MONTH" | "PRICE_CHANGE_1WEEK" | "PRICE_CHANGE_1YEAR" | "PRICE_CHANGE_24HOURS";
export type SortOrder = "ASC" | "DESC";
export type AssetsViewQuery$variables = {
  after?: string | null | undefined;
  first: number;
  groups?: ReadonlyArray<AssetsListGroup> | null | undefined;
  searchTerm?: string | null | undefined;
  sortBy?: AssetsListSortBy | null | undefined;
  sortOrder?: SortOrder | null | undefined;
  tags?: ReadonlyArray<string> | null | undefined;
};
export type AssetsViewQuery$data = {
  readonly assetGroups: ReadonlyArray<{
    readonly __typename: "AssetGroup";
    readonly key: AssetsGroupKey;
    readonly value: ReadonlyArray<AssetsListGroup>;
  }>;
  readonly assets: {
    readonly __typename: "AssetsConnection";
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly id: string;
        readonly isin?: string | null | undefined;
        readonly legalUrl: string | null | undefined;
        readonly logoUrl: string | null | undefined;
        readonly marketCap: number | null | undefined;
        readonly name: string | null | undefined;
        readonly price: PrecisionFloat | null | undefined;
        readonly price52WeeksHigh: PrecisionFloat | null | undefined;
        readonly price52WeeksLow: PrecisionFloat | null | undefined;
        readonly priceChange1Month: ValueChange | null | undefined;
        readonly priceChange1Week: ValueChange | null | undefined;
        readonly priceChange1Year: ValueChange | null | undefined;
        readonly priceChange24Hours: ValueChange | null | undefined;
        readonly priceDailyHigh: PrecisionFloat | null | undefined;
        readonly priceDailyLow: PrecisionFloat | null | undefined;
        readonly prices: ReadonlyArray<{
          readonly fiat: {
            readonly name: string | null | undefined;
            readonly symbol: string | null | undefined;
          } | null | undefined;
          readonly value: PrecisionFloat | null | undefined;
        }> | null | undefined;
        readonly symbol: string | null | undefined;
      };
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type AssetsViewQuery = {
  response: AssetsViewQuery$data;
  variables: AssetsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groups"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchTerm"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortOrder"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tags"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetGroup",
  "kind": "LinkedField",
  "name": "assetGroups",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    (v7/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v10 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "groups",
        "variableName": "groups"
      },
      {
        "kind": "Variable",
        "name": "searchTerm",
        "variableName": "searchTerm"
      },
      {
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "sortBy"
      },
      {
        "kind": "Variable",
        "name": "sortOrder",
        "variableName": "sortOrder"
      },
      {
        "kind": "Variable",
        "name": "tags",
        "variableName": "tags"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceChange1Week",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceChange1Year",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceChange1Month",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceChange24Hours",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceDailyHigh",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceDailyLow",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price52WeeksLow",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price52WeeksHigh",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "marketCap",
  "storageKey": null
},
v25 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isin",
    "storageKey": null
  }
],
v26 = {
  "kind": "InlineFragment",
  "selections": (v25/*: any*/),
  "type": "StockAsset",
  "abstractKey": null
},
v27 = {
  "kind": "InlineFragment",
  "selections": (v25/*: any*/),
  "type": "EtfAsset",
  "abstractKey": null
},
v28 = {
  "kind": "InlineFragment",
  "selections": (v25/*: any*/),
  "type": "EtcAsset",
  "abstractKey": null
},
v29 = {
  "kind": "InlineFragment",
  "selections": (v25/*: any*/),
  "type": "EquityStockAsset",
  "abstractKey": null
},
v30 = {
  "kind": "InlineFragment",
  "selections": (v25/*: any*/),
  "type": "EquityEtfAsset",
  "abstractKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "legalUrl",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AssetsViewQuery",
    "selections": [
      (v9/*: any*/),
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "AssetsConnection",
        "kind": "LinkedField",
        "name": "assets",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AssetsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Price",
                    "kind": "LinkedField",
                    "name": "prices",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Fiat",
                        "kind": "LinkedField",
                        "name": "fiat",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v32/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "AssetsViewQuery",
    "selections": [
      (v9/*: any*/),
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "AssetsConnection",
        "kind": "LinkedField",
        "name": "assets",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AssetsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Price",
                    "kind": "LinkedField",
                    "name": "prices",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Fiat",
                        "kind": "LinkedField",
                        "name": "fiat",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v32/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "57e4d1120d4811d8f110aa866cb8d4f6",
    "id": null,
    "metadata": {},
    "name": "AssetsViewQuery",
    "operationKind": "query",
    "text": "query AssetsViewQuery(\n  $after: String\n  $first: Int!\n  $sortBy: AssetsListSortBy\n  $sortOrder: SortOrder\n  $searchTerm: String\n  $groups: [AssetsListGroup!]\n  $tags: [String!]\n) {\n  assetGroups {\n    key\n    value\n    __typename\n  }\n  assets(input: {after: $after, first: $first, sortBy: $sortBy, sortOrder: $sortOrder, searchTerm: $searchTerm, groups: $groups, tags: $tags}) {\n    edges {\n      node {\n        id\n        name\n        symbol\n        logoUrl\n        price\n        priceChange1Week\n        priceChange1Year\n        priceChange1Month\n        priceChange24Hours\n        priceDailyHigh\n        priceDailyLow\n        price52WeeksLow\n        price52WeeksHigh\n        prices {\n          fiat {\n            name\n            symbol\n            id\n          }\n          value\n        }\n        marketCap\n        ... on StockAsset {\n          isin\n        }\n        ... on EtfAsset {\n          isin\n        }\n        ... on EtcAsset {\n          isin\n        }\n        ... on EquityStockAsset {\n          isin\n        }\n        ... on EquityEtfAsset {\n          isin\n        }\n        legalUrl\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    __typename\n  }\n}\n"
  }
};
})();

(node as any).hash = "d1cdf5089a9bcfc8c877eb297688c2d3";

export default node;
